export const NAME = 'build';

export const NEW_BUILDS = `${NAME}/NEW_BUILDS`;

export const WS_NEW_BUILD = 'newBuild';
export const BD_PATH = '\\\\regression\\build_data';

export const BUILD_RELEASE = 'Release';
export const BUILD_PRODUCTION = 'Production';
export const BUILD_PREBUILD = 'Prebuild';
export const BUILD_TOPIC = 'Topic';
export const BUILD_RC = 'RC';

export const LATEST_BY_IMAGE = 'Latest by Image';
export const LATEST_RELEASE = 'Latest Release';
export const EXPECTED = 'Expected';

export const FETCH_DAYS = 60;

export const PRODUCTS = {
  IEF_ENGINE: 'ief_engine',
  PROCESS: 'process',
  EXAMINE: 'examine',
  IEFRV: 'iefrv',

  IEF: 'ief',
  AXIOM: 'axiom'
};

export const CCF_BY_PRODUCT = {
  [PRODUCTS.IEF_ENGINE]: true,
  [PRODUCTS.IEFRV]: true,
  [PRODUCTS.PROCESS]: false,
  [PRODUCTS.EXAMINE]: false,
  [PRODUCTS.IEF]: true,
  [PRODUCTS.AXIOM]: false,
};

export const PROD_BY_PRODUCT = {
  [PRODUCTS.IEF_ENGINE]: PRODUCTS.IEF,
  [PRODUCTS.IEFRV]: PRODUCTS.IEF,
  [PRODUCTS.PROCESS]: PRODUCTS.AXIOM,
  [PRODUCTS.EXAMINE]: PRODUCTS.AXIOM
};

export const PRODUCTS_BY_PROD = Object.keys(PROD_BY_PRODUCT).reduce((acc, p) => {
  const prod = PROD_BY_PRODUCT[p];
  if (!Object.hasOwnProperty.call(acc, prod)) {
    acc[prod] = [];
  }

  acc[prod].push(p);

  return acc;
}, {});

export const PRODUCT_VERSIONS = {
  [PRODUCTS.IEF_ENGINE]: '111',
  [PRODUCTS.PROCESS]: '111',
  [PRODUCTS.EXAMINE]: '222',
  [PRODUCTS.IEFRV]: '777'
};

export const BIT_TYPE = {
  PROD: 1,
  PREBUILD: 2,
  TOPIC: 4
};
export const VERSION_TYPE = {
  RELEASE: 0,
  PROD: 1,
  PREBUILD: 2,
  TOPIC: 3,
  DEV: 4
};

export const buildTypesBitFieldMapper = num => {
  const types = [];
  if (num & BIT_TYPE.PROD) {
    types.push(BUILD_PRODUCTION);
  }
  if (num & BIT_TYPE.PREBUILD) {
    types.push(BUILD_PREBUILD);
  }
  if (num & BIT_TYPE.TOPIC) {
    types.push(BUILD_TOPIC);
  }
  return types;
};

export const buildTypesMapper = build => {
  const types = [];
  if (build.is_release) {
    types.push(LATEST_RELEASE);
  }
  if (build.is_rc) {
    types.push(BUILD_RC);
  }
  if (build.is_prod) {
    types.push(BUILD_PRODUCTION);
  }
  if (build.is_topic) {
    types.push(BUILD_TOPIC);
  }
  if (build.is_prebuild) {
    types.push(BUILD_PREBUILD);
  }
  return types;
};

export const FRIENDLY_BUILD_NAMES = {
  [PRODUCTS.EXAMINE]: 'Examine',
  [PRODUCTS.IEF_ENGINE]: 'IEF',
  [PRODUCTS.IEFRV]: 'Report Viewer',
  [PRODUCTS.PROCESS]: 'Process',
  [PRODUCTS.AXIOM]: 'AXIOM',
  [PRODUCTS.IEF]: 'IEF'
};

export const PRODUCT_NAMES = [
  PRODUCTS.AXIOM,
  PRODUCTS.IEF
];

export const COMPONENT_NAMES = [
  PRODUCTS.EXAMINE,
  PRODUCTS.IEF_ENGINE,
  PRODUCTS.IEFRV,
  PRODUCTS.PROCESS
];

export const JIRA = 'Jira';

export const EXPECTED_NAMES = [
  JIRA
];

const components = COMPONENT_NAMES.map(p => {
  return {
    text: FRIENDLY_BUILD_NAMES[p],
    value: p
  };
});

const products = PRODUCT_NAMES.map(p => {
  return {
    text: FRIENDLY_BUILD_NAMES[p],
    value: p
  };
});

const expected = EXPECTED_NAMES.map(p => {
  return {
    text: p,
    value: p
  };
});

export const BUILD_TYPE_NAMES = [
  BUILD_RELEASE,
  BUILD_PRODUCTION,
  BUILD_PREBUILD,
  BUILD_TOPIC
];

export const BUILD_TYPE_VALUES = {
  [LATEST_RELEASE]: products,
  [BUILD_PRODUCTION]: products,
  [BUILD_PREBUILD]: components,
  [BUILD_TOPIC]: components,
  [EXPECTED]: expected
};

export const INSTALLER_ROOT = `${BD_PATH}\\production`;

export const CHECKBOX_OFFSET = 3;
export const MID_CHECKBOX_OFFSET = 1;

export const getProdNumberKey = (product, buildNumber) => {
  if (Object.hasOwnProperty.call(PROD_BY_PRODUCT, product)) {
    product = PROD_BY_PRODUCT[product];
  }

  return `${product}_${buildNumber}`;
};
export const getVersionKey = (product, version) => `${product}_${version}`;

export const getComponentByProduct = product => PRODUCTS_BY_PROD[product];
export const isProductCcf = product => product && product.includes('ief');

export const getBuildId = build => build && build.id;
export const getBuildProduct = build => build && build.product;
export const getBuildNumber = build => build && build.build;
export const getBuildVersion = build => build && build.version;
export const getBuildMajor = build => build && build.major;
export const getBuildMinor = build => build && build.minor;
export const getBuildRevision = build => build && build.patch;
export const getBuildBuildNumber = build => build && build.build;

export const getBuildProdNumberKey = build =>
  build && getProdNumberKey(getBuildProduct(build), getBuildNumber(build));
export const getBuildVersionKey = build =>
  build && getVersionKey(getBuildProduct(build), getBuildVersion(build));
export const getBuildFriendlyName = build =>
  build && FRIENDLY_BUILD_NAMES[getBuildProduct(build)];

export const getBuildTypeOptions = (isBaseline) => isBaseline ?
  [LATEST_BY_IMAGE, LATEST_RELEASE, ...BUILD_TYPE_NAMES.slice(1), EXPECTED] :
  [LATEST_RELEASE, ...BUILD_TYPE_NAMES.slice(1)];

export const getProdNameByProductName = (product) =>
  PRODUCTS_BY_PROD[product] ? PRODUCTS_BY_PROD[product][0] : '';

export const getProdNamesByProductName = (product) =>
  PRODUCTS_BY_PROD[product] || [];


// WEBPACK FOOTER //
// src/helpers/build.js